import type { TechFormVesselDraftBoundaryProps } from "../models/tech-form-vessel-cache.models";
import { selectTechFormVesselDraftAtom } from "../state/tech-form-vessel-cache.atoms";
import { getTechFormVesselCacheKey } from "../utils/get-tech-form-vessel-cache-key.utils";
import { useSetAtom } from "jotai";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export function TechFormVesselDraftBoundary({ mode, children }: TechFormVesselDraftBoundaryProps) {
  const { imoNumber = "", vesselName = "" } = useParams();
  const selectVesselDraft = useSetAtom(selectTechFormVesselDraftAtom);
  const vesselKey = getTechFormVesselCacheKey({ imoNumber, vesselName, mode });
  const [selectedKey, setSelectedKey] = useState<string | null>(null);

  useEffect(() => {
    selectVesselDraft({ imoNumber, vesselName, mode });
    setSelectedKey(vesselKey);
  }, [imoNumber, vesselName, mode, vesselKey, selectVesselDraft]);

  if (!vesselKey || selectedKey !== vesselKey) return <div role="status">Loading vessel draft...</div>;
  return <>{children}</>;
}
